<div class="mb-2 mt-2 d-inline-flex" *ngIf="!isDisabled">
  <button mat-button color="primary" class="back-btn"
    (click)="navigate()" aria-label="Botón atrás">
    <em class="fa fa-chevron-left "></em>
    {{'Volver' | translate}}
  </button>
</div>
